import { useEffect, useState } from 'react';
import { ExoRichTextEditor } from '../exo/ExoRichTextEditor';

export const StepRichtText = ({
  dataCollection,
  updateValidation,
  updateDataCollection,
  dataKey = 'content',
}) => {
  useEffect(() => {}, []);

  const [startHTML, setStartHTML] = useState('');
  const [currentHTML, setCurrentHTML] = useState('');

  useEffect(() => {
    if (currentHTML !== dataCollection[dataKey])
      setStartHTML(dataCollection[dataKey]);
  }, [dataCollection[dataKey]]);

  function handleChange(data) {
    setCurrentHTML(data);
    updateValidation(Boolean(data));
    updateDataCollection({ [dataKey]: data });
  }

  return (
    <ExoRichTextEditor startHTML={startHTML} onHtmlChange={handleChange} />
  );
};
